module.exports = __webpack_public_path__ + "static/media/visa.b3e61bd7.svg";